import { WizAuthority } from '@/containers/common'
export default (initialValue = {}) => [
  {
    name: "id",
    formItem: {
      type: "hidden",
      initialValue: initialValue.id,
    },
  },
  {
    title: "名称",
    name: "name",
    formItem: {
      maxLength: 25,
      placeholder: "名称最多输入25个字",
      initialValue: initialValue.name,
      rules: [
        {
          required: true,
          message: "请输入名称",
        },
        {
          pattern: /^[\u4e00-\u9fa5a-zA-z0-9\.\-\[\]_·]*$/,
          message: "名称只能包含中文、英文、数字、[、]、-、_、.、·",
        },
      ],
    },
  },
  {
    title: "受众组",
    name: "groupScope",
    formItem: {
      type: "diy",
      diy: WizAuthority,
      rules: [
        {
          required: true,
          message: "请选择受众",
        },
      ],
      initialValue: initialValue.groupScope,
      keys: ["orgIds", "positionIds", "positionCategoryIds", "personIds"],
      hasRadioGroup: false
    },
  },
  {
    title: "管理范围",
    name: "managerScope",
    formItem: {
      type: "diy",
      diy: WizAuthority,
      initialValue: initialValue.managerScope,
      keys: ["orgIds", "positionIds", "positionCategoryIds", "personIds"],
      hasRadioGroup: false
    },
  },
  {
    title: "组说明",
    name: "intro",
    formItem: {
      type: 'textarea',
      initialValue: initialValue.intro,
    },
  },
];
